import { getStaticAssetsKitCollectionResponse } from '~/utils/assetskitStaticCollections'

export const buildAssetsKitCollectionLookupRoute = (spaceId: string, slug: string) =>
  `/api/assetskit-collection?space_id=${encodeURIComponent(spaceId)}&slug=${encodeURIComponent(slug)}`

export async function fetchAssetsKitCollectionBySlug(spaceId: string, slug: string, lang?: string) {
  const route = lang
    ? `${buildAssetsKitCollectionLookupRoute(spaceId, slug)}&lang=${encodeURIComponent(lang)}`
    : buildAssetsKitCollectionLookupRoute(spaceId, slug)

  return await $fetch('/api/assetskit-collection', {
    query: {
      space_id: spaceId,
      slug,
      ...(lang ? { lang } : {})
    }
  })
    .then((response: any) => {
      if (response?.collection) {
        return response
      }

      return getStaticAssetsKitCollectionResponse(spaceId, slug, {
        rawLookup: response?.rawLookup || response || null,
        lookupPayloads: response?.lookupPayloads || [],
        routes: response?.routes || [route]
      }) || {
        collection: null,
        rawLookup: response?.rawLookup || response || null,
        lookupPayloads: response?.lookupPayloads || [],
        routes: response?.routes || [route],
        error: response?.error || 'AssetsKit fetch failed'
      }
    })
    .catch((error: any) => (
      getStaticAssetsKitCollectionResponse(spaceId, slug, {
        rawLookup: error?.data || null,
        lookupPayloads: [],
        routes: [route]
      }) || {
        collection: null,
        rawLookup: null,
        lookupPayloads: [],
        routes: [route],
        error: error?.data?.statusMessage || error?.message || 'AssetsKit fetch failed'
      }
    ))
}
